import React from 'react';
import { ElevesDashboardProf } from '../../../types/classe/maClasse';
import { useQuery } from '@apollo/client';
import GET_ALL_AVAILABLE_QUIZ from '../../../graphql/query/quiz/allQuiz';
import { AllQuizzQuery } from '../../../graphql/generated/graphql';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import { TableData } from '../../../components/organisms/Table/TableData';
import { TableDataLineQuizProf } from '../../../components/organisms/Table/TableData/TableDataLineQuizProf';

interface QuizTabProps {
  eleves?: ElevesDashboardProf[];
}

export const QuizTab = ({ eleves }: QuizTabProps) => {
  const { loading, error, data } = useQuery<AllQuizzQuery>(
    GET_ALL_AVAILABLE_QUIZ
  );

  if (loading) return <LoadingContainer />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError(
            'Erreur dans la récupération des données (classe ou Quiz)'
          )
        }
      />
    );

  if (!data.availableQuiz) return null;
  const tabLabels = ['Quiz', 'Dates', 'Statut', 'Suivi'];
  return (
    <TableData tabLabels={tabLabels}>
      {data.availableQuiz?.map((quiz, i) => (
        <TableDataLineQuizProf key={i} quiz={quiz} eleves={eleves} />
      ))}
    </TableData>
  );
};
